import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/concat';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { fireCustomErrorAnalytics } from '@atlassian/jira-servicedesk-knowledge-common';
import { getArticleWithExpandParams } from '@atlassian/jira-servicedesk-knowledge-services';
import { FETCH_ARTICLE } from '../../state/actions/fetch-article';
import { fetchArticleEditPermission } from '../../state/actions/fetch-article-edit-permission';
import { fetchArticleFailure } from '../../state/actions/fetch-article-failure';
import { fetchArticleSuccess } from '../../state/actions/fetch-article-success';
import { getActivationId, getProjectId } from '../../state/selectors/base';
import type { State } from '../../state/types';
import { PACKAGE_NAME } from '../../view/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(FETCH_ARTICLE).mergeMap((action) => {
		const projectId = getProjectId(store.getState());
		const activationId = getActivationId(store.getState());
		const { id, accountId, createAnalyticsEvent } = action.payload;
		const getArticleObservable = getArticleWithExpandParams(projectId, id, activationId, [
			'category',
			'labels',
		]);
		return getArticleObservable
			.mergeMap((article) =>
				Observable.concat(
					Observable.of(fetchArticleSuccess(article)),
					Observable.of(
						fetchArticleEditPermission(id, accountId, createAnalyticsEvent, article.spaceKey || ''),
					),
				),
			)
			.catch((error) => {
				fireCustomErrorAnalytics({
					error,
					event: createAnalyticsEvent({}),
					id: 'fetchArticle failure',
					packageName: PACKAGE_NAME,
				});
				return Observable.of(fetchArticleFailure({ id, statusCode: error.statusCode }));
			});
	});
